import { IntlShape } from 'react-intl'
import { create, enforce, test } from 'vest'
import messages from './messages'

const ID_REGEX = new RegExp(/^\d+$/)

export function fileValidationSuite(intl: IntlShape, maxEntries: number) {
  return create((entries: string[]) => {
    const { formatMessage: i18n } = intl
    const { validation } = messages

    test('entries', i18n(validation.listMaxSize, { count: maxEntries }), () => {
      enforce(entries.length).lte(maxEntries)
    })

    test('entries', i18n(validation.noValidEntries), () => {
      enforce(entries).isNotEmpty()
    })

    test('entries', () => {
      const invalidEntriesCount = entries.filter(
        (id) => !ID_REGEX.test(id)
      ).length

      if (invalidEntriesCount > 0)
        throw i18n(validation.invalidEntries, { count: invalidEntriesCount })
    })
  })
}
